import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import IconButton from '../IconButton';

import InputRange from '../InputRange';
import TooltipWrapper from '../TooltipWrapper';
import SoundIndicator from './components/SoundIndicator';
import { useVolumeControl } from './hooks/useVolumeControl';
import styles from './styles.module.scss';

export interface IVolumeControlProps {
  openInDirection?: 'vertical' | 'horizontal';
  volumePercent: number;
  onChange: (volume: number) => void;
}

const VolumeControl = ({ openInDirection = 'horizontal', volumePercent, onChange }: IVolumeControlProps) => {
  const { isOpen, handleChangeValue, handleOpen, handleClose, handleToggleMuteVolume } = useVolumeControl({
    onChange,
    volumePercent,
  });
  const { t } = useTranslation('common');

  return (
    <div
      data-testid='container-volume-control'
      onMouseEnter={handleOpen}
      onMouseLeave={handleClose}
      className={classNames(styles.container, styles[openInDirection], {
        [styles.opened]: isOpen,
      })}
    >
      <div className={styles.content}>
        <TooltipWrapper tooltipText={t('tooltips.volume')} tooltipPosition='top'>
          <IconButton
            onFocus={handleOpen}
            onBlur={handleClose}
            icon={<SoundIndicator volume={volumePercent} />}
            data-testid='volume-control-toggle'
            className={styles.soundToggle}
            onClick={handleToggleMuteVolume}
          />
        </TooltipWrapper>
        <div className={classNames(styles.inputRangeContainer)}>
          <InputRange
            data-testid='volume-control-input-range'
            onKeyDown={(event) => {
              if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') {
                event.stopPropagation();
              }
            }}
            onFocus={handleOpen}
            onBlur={handleClose}
            onChange={handleChangeValue}
            value={volumePercent}
            step={1}
          />
        </div>
      </div>
    </div>
  );
};

export default VolumeControl;
